import IndividualCircularLoader from '../../../../components/Loader/IndividualCircularLoader';
import useAuth from '../../../auth/useAuth';
import useSubscription from '../../hooks/useSubscription';
import styles from './registrationSubscribedService.module.scss';

const RegistrationSubscribedServices = () => {
  const { isManager } = useAuth({});
  const { subscription, subscriptionStatusPending } = useSubscription();

  if (!isManager) return null;

  const price = `${subscription?.price ?? '-'}€ / mois`;

  return (
    <div className={styles.container}>
      <h3>Vos services souscrits</h3>
      {subscriptionStatusPending ? (
        <IndividualCircularLoader size={30} />
      ) : (
        <span className={styles.data}>{price}</span>
      )}
    </div>
  );
};

export default RegistrationSubscribedServices;
